import { useEffect, useState } from 'react';
import { useParams, Navigate, useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import api from '../../services/api';
import SubscriptionModal from '../../components/stripe/SubscriptionModal';
import { loginUrl } from '../../utils/loginRedirect';

export default function Abonnement() {
    const { scope } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuthStore();
    const [scopeInfo, setScopeInfo] = useState(null);

    const isCompte = location.pathname.startsWith('/compte/');
    const basePath = scope === 'thematique-personnalisable'
        ? '/compte/quiz/mes-thematiques'
        : isCompte ? `/compte/quiz/${scope}` : `/${scope}`;

    useEffect(() => {
        api.get('/scopes/detail.php', { params: { slug: scope } })
            .then(({ data }) => setScopeInfo(data.data.scope))
            .catch(() => navigate(basePath));
    }, [scope]);

    if (!user) return <Navigate to={loginUrl()} replace />;
    if (!scopeInfo) return null;

    const utId = new URLSearchParams(window.location.search).get('user_thematique_id');

    return (
        <SubscriptionModal
            scopeId={scopeInfo.id}
            scopeLabel={scopeInfo.label}
            onClose={() => navigate(basePath)}
            extraBody={utId ? { user_thematique_id: parseInt(utId) } : {}}
            pricing={scopeInfo}
            source="page_abonnement"
        />
    );
}
